function initMobileNavigation(container) {
  if (!container || container.dataset.mobileNavigationReady === 'true') return;
  container.dataset.mobileNavigationReady = 'true';

  function getDirectChild(disclosure, selector) {
    return Array.from(disclosure.children).find(function(child) {
      return child.matches(selector);
    });
  }

  function updateToggleLabel(toggle, expanded) {
    const title = toggle.dataset.mobileNavigationTitle || '';
    toggle.setAttribute('aria-label', `${expanded ? 'Hide' : 'Show'} ${title} submenu`);
  }

  function closeDisclosure(disclosure, returnFocus) {
    const row = getDirectChild(disclosure, '.mobile-navigation__row');
    const toggle = row ? row.querySelector('[data-mobile-navigation-toggle]') : null;
    const panel = getDirectChild(disclosure, '[data-mobile-navigation-panel]');
    if (!toggle || !panel) return;

    panel.querySelectorAll('[data-mobile-navigation-disclosure].is-open').forEach(function(nestedDisclosure) {
      closeDisclosure(nestedDisclosure, false);
    });
    disclosure.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    updateToggleLabel(toggle, false);
    panel.hidden = true;

    if (returnFocus) toggle.focus();
  }

  function openDisclosure(disclosure) {
    const row = getDirectChild(disclosure, '.mobile-navigation__row');
    const toggle = row ? row.querySelector('[data-mobile-navigation-toggle]') : null;
    const panel = getDirectChild(disclosure, '[data-mobile-navigation-panel]');
    if (!toggle || !panel) return;

    disclosure.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    updateToggleLabel(toggle, true);
    panel.hidden = false;
  }

  container.querySelectorAll('[data-mobile-navigation-disclosure]').forEach(function(disclosure) {
    const row = getDirectChild(disclosure, '.mobile-navigation__row');
    const toggle = row ? row.querySelector('[data-mobile-navigation-toggle]') : null;
    if (!toggle) return;

    toggle.addEventListener('click', function() {
      if (disclosure.classList.contains('is-open')) {
        closeDisclosure(disclosure, false);
      } else {
        openDisclosure(disclosure);
      }
    });
  });

  container.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;

    const disclosure = event.target.closest('[data-mobile-navigation-disclosure].is-open');
    if (!disclosure) return;

    event.preventDefault();
    closeDisclosure(disclosure, true);
  });

  const miniCartTrigger = container.querySelector('.mobile-nav__mobile-header .js-mini-cart-trigger');
  if (miniCartTrigger) {
    miniCartTrigger.addEventListener('click', function() {
      WAU.Slideout._closeByName('slideout-mobile-navigation');
    });
  }
}

document.querySelectorAll('[data-section-type="mobile-navigation"]').forEach(function(container){
  initMobileNavigation(container);
});

document.addEventListener("shopify:section:select", function(event) {
  if ( !event.target.querySelector('[data-section-type="mobile-navigation"]') ) return false;
  WAU.Slideout._openByName("slideout-mobile-navigation");
});

document.addEventListener("shopify:section:deselect", function(event) {
  if ( !event.target.querySelector('[data-section-type="mobile-navigation"]') ) return false;
  WAU.Slideout._closeByName("slideout-mobile-navigation");
});

document.addEventListener("shopify:block:select", function(event) {
  if ( !event.target.querySelector('[data-section-type="mobile-navigation"]') ) return false;
  WAU.Slideout._openByName("slideout-mobile-navigation");
});

document.addEventListener('shopify:section:load', function(event) {
  const container = event.target.matches('[data-section-type="mobile-navigation"]')
    ? event.target
    : event.target.querySelector('[data-section-type="mobile-navigation"]');
  initMobileNavigation(container);
});
